<template src="./ListFormTemplates.html"></template>
<script>
import { getFormTemplates, deleteFormTemplate, duplicateFormTemplate, archiveFormTemplate, publishFormTemplate } from '../../../services'

export default {
  name: 'ListFormTemplates',
  data: () => ({
    templates: [],
    search: '',
    statusFilter: ''
  }),

  created () {
    this.loadTemplates()
  },

  methods: {
    async loadTemplates () {
      try {
        this.templates = await getFormTemplates({ status: this.statusFilter || undefined })
      } catch (err) {
        console.log('List form templates:', err)
      }
    },

    confirmDelete (template) {
      this.$swal({
        title: '¿Está seguro de eliminar la plantilla?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((value) => {
        if (value) {
          this.removeTemplate(template)
        }
      })
    },

    async removeTemplate (template) {
      try {
        await deleteFormTemplate(template.id)
        this.$swal({
          text: 'Se eliminó la plantilla.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.templates = []
        this.loadTemplates()
      } catch (err) {
        console.error('Error on remove template:', err)
        this.$swal({
          text: err.message || 'Ocurrió un error, intenta más tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },

    async duplicate (template) {
      try {
        await duplicateFormTemplate(template.id)
        this.$swal({
          text: 'Plantilla duplicada como borrador.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.templates = []
        this.loadTemplates()
      } catch (err) {
        console.error('Error on duplicate template:', err)
        this.$swal({
          text: err.message || 'Ocurrió un error, intenta más tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },

    async duplicateAndEdit (template) {
      try {
        const created = await duplicateFormTemplate(template.id)
        this.$router.push({ name: 'Editor Plantilla', params: { id: created.id } })
      } catch (err) {
        console.error('Error on duplicate template:', err)
        this.$swal({
          text: err.message || 'Ocurrió un error al duplicar.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },

    async archive (template) {
      try {
        await archiveFormTemplate(template.id)
        this.$swal({
          text: 'Plantilla archivada.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.templates = []
        this.loadTemplates()
      } catch (err) {
        console.error('Error on archive template:', err)
        this.$swal({
          text: err.message || 'Ocurrió un error, intenta más tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },

    async republish (template) {
      const confirmed = await this.$swal({
        title: '¿Republicar esta plantilla?',
        text: 'Se publicara de nuevo esta plantilla. Si hay otra publicada para los mismos servicios, sera archivada.',
        icon: 'warning',
        buttons: ['Cancelar', 'Republicar']
      })
      if (!confirmed) return
      try {
        await publishFormTemplate(template.id)
        this.$swal({
          text: 'Plantilla republicada.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.templates = []
        this.loadTemplates()
      } catch (err) {
        console.error('Error on republish template:', err)
        this.$swal({
          text: err?.response?.data?.message || err.message || 'Ocurrió un error al republicar.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },

    async publish (template) {
      try {
        await publishFormTemplate(template.id)
        this.$swal({
          text: 'Plantilla publicada.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.templates = []
        this.loadTemplates()
      } catch (err) {
        console.error('Error on publish template:', err)
        this.$swal({
          text: err.message || 'Ocurrió un error, intenta más tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },

    editTemplate (template) {
      this.$router.push({ name: 'Editor Plantilla', params: { id: template.id } })
    },

    statusColor (status) {
      if (status === 'PUBLISHED') return 'green'
      if (status === 'ARCHIVED') return 'orange'
      return 'grey'
    },

    statusLabel (status) {
      if (status === 'PUBLISHED') return 'Publicada'
      if (status === 'ARCHIVED') return 'Archivada'
      return 'Borrador'
    }
  },

  computed: {
    filteredItems () {
      if (!this.search) return this.templates
      const query = this.search.toLowerCase()
      return this.templates.filter((t) => {
        const text = (t.name || '') + ' ' + (t.description || '')
        return text.toLowerCase().indexOf(query) > -1
      })
    }
  },

  watch: {
    statusFilter () {
      this.loadTemplates()
    }
  }
}
</script>
